// removed by extract-text-webpack-plugin
module.exports = {"chipView":"FilterChip__chipView___HYeKz","chipViewActive":"FilterChip__chipViewActive___1kjT7 FilterChip__chipView___HYeKz","chip":"FilterChip__chip___2Rf3L","chipCount":"FilterChip__chipCount___2c11l","chipActive":"FilterChip__chipActive___27w3b FilterChip__chip___2Rf3L","chipInactive":"FilterChip__chipInactive___1VN03 FilterChip__chip___2Rf3L","chipValue":"FilterChip__chipValue___1ONGO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterChip/FilterChip.css
// module id = 992
// module chunks = 0